import Bin from "./SVG/bin.svg?react";

const BinIcon = () => {
  return <Bin />;
};

export default BinIcon;
